import { Service } from '@bringg/types';
import axios from 'axios';

import { getAdminApiEndpoint, getDashboardSdk } from '../helpers';

async function getServices(): Promise<Array<Service>> {
  return (await axios.get(`${getAdminApiEndpoint(await getDashboardSdk())}/services_setup`)).data;
}

async function getServicesList() {
  return (await axios.get(`${getAdminApiEndpoint(await getDashboardSdk())}/services_setup/list`)).data;
}

async function postCreateTaskService(): Promise<Service | null> {
  const list = await getServicesList();
  const createOrder = list.find((item: { label: string; id: string }) => item.label === 'Create Order');
  if (!createOrder) {
    console.error("Can't find create order service");
    return null;
  }

  const resp = await axios.post(`${getAdminApiEndpoint(await getDashboardSdk())}/services_setup`, {
    action: createOrder,
  });
  return resp.data.service;
}

export async function getCreateTaskServiceUrl(): Promise<string | null> {
  const services = await getServices();
  const createTaskService =
    services.find((service) => service.action_name === 'create_task') || (await postCreateTaskService());

  return createTaskService?.url ?? null;
}
